import * as React from "react";
import EditorialBase from "components/flexComponents/Editorial/factory/EditorialBase";
import { UitkCardAloha } from "uitk-react-cards";
import { UitkText, UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { ContentProps, EditorialFactoryProps } from "components/flexComponents/Editorial/typings";
import { decorateEditorialHtml } from "components/flexComponents/Editorial/ContentUtilities";
import { UitkPrimaryButton } from "uitk-react-button";
import MediaDisplay from "../items/MediaDisplay";

export class HalfMediaEditorial extends EditorialBase {
  public constructor(editorial: EditorialFactoryProps) {
    super(editorial);
  }

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate(props: ContentProps) {
    const { items, cardLinkLabel, cardLinkUrl, title: moduleTitle, subtitle: moduleSubtitle } = this.editorial;
    const { text, title, media, subtitle, id: itemId } = items[0];

    if (!media || media.length === 0) {
      return null;
    }

    return (
      <UitkSpacing padding={{ block: "three" }}>
        <div id={this.id} data-fm={this.fmId} data-fm-title-id={this.fmTitleId} className="HalfMediaEditorial">
          <UitkCardAloha border>
            <div>
              <UitkLayoutGrid columns={{ small: 1, medium: 2 }} justifyContent="space-between">
                <UitkLayoutGridItem>
                  <MediaDisplay id={itemId} media={media} title={title} />
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <div>
                    <UitkSpacing padding={{ block: "three", inline: "four" }}>
                      <div>
                        {moduleTitle && (
                          <UitkSpacing margin={{ blockend: "two" }}>
                            <div>
                              <UitkHeading tag="h2" size={5}>
                                {moduleTitle}
                              </UitkHeading>
                              {moduleSubtitle && <UitkSubheading>{moduleSubtitle}</UitkSubheading>}
                            </div>
                          </UitkSpacing>
                        )}
                        {title && (
                          <div>
                            <UitkHeading tag={moduleTitle ? "h3" : "h2"} size={5}>
                              {title}
                            </UitkHeading>
                            {subtitle && <UitkSubheading>{subtitle}</UitkSubheading>}
                          </div>
                        )}
                        <UitkSpacing margin={{ blockstart: "two" }}>
                          <UitkText size={300}>
                            <div dangerouslySetInnerHTML={decorateEditorialHtml(text)} />
                          </UitkText>
                        </UitkSpacing>
                        {cardLinkUrl && cardLinkLabel && (
                          <UitkSpacing margin={{ blockstart: "four" }}>
                            <UitkPrimaryButton text={cardLinkLabel} href={cardLinkUrl} aria-label={cardLinkLabel} />
                          </UitkSpacing>
                        )}
                      </div>
                    </UitkSpacing>
                  </div>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </div>
          </UitkCardAloha>
        </div>
      </UitkSpacing>
    );
  }
}

export default HalfMediaEditorial;
